import ACTION, { SAFETYSECURITY_DATA_STATE } from './creator'

const init = {
  status: SAFETYSECURITY_DATA_STATE.PENDING,
  message: '',
  dataForm: [],
}

export const AuxVerificationApplicationByTenantSB = (state = init, { type, payload }) => {
  switch (type) {
    case ACTION.SAFETYSECURITY_DATA.PENDING:
    case ACTION.SAFETYSECURITY_DATA.SUCCESS:
    case ACTION.SAFETYSECURITY_DATA.FAILURE:
      return { ...state, ...payload }
    default:
      return state
  }
}
export const sbVerifyApplication = (state = init, { type, payload }) => {
  switch (type) {
    case ACTION.VERIFY.PENDING:
    case ACTION.VERIFY.SUCCESS:
    case ACTION.VERIFY.FAILURE:
      return { ...state, ...payload }
    default:
      return state
  }
}
export const sbRejectApplication = (state = init, { type, payload }) => {
  switch (type) {
    case ACTION.REJECT.PENDING:
    case ACTION.REJECT.SUCCESS:
    case ACTION.REJECT.FAILURE:
      return { ...state, ...payload }
    default:
      return state
  }
}
